import React, { Fragment, useState, useEffect, useContext } from 'react';
import useApi from "../../../../../hooks/useApi";
import { Col, Label, Row, Spinner } from 'reactstrap';
import { ProjectContext } from '../../../../../context/Project';
import Bathroom from '../../../assets/spaces/bathroom.svg';
import Kitchen from '../../../assets/spaces/kitchen.svg';
import Living from '../../../assets/spaces/living.svg';

function SpaceSelection ({ onError, onSpaceChange }) {
    const projectTypeApi = useApi('projecttype');
    const { setType, getType } = useContext(ProjectContext);

    const [selectedSpace, setSelectedSpace] = useState(null);

    useEffect(() => {
        if (!projectTypeApi.loading) {
            if (!projectTypeApi.error) {
                projectTypeApi.get();
            } else {
                handleError(projectTypeApi.error.detail);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [projectTypeApi.error]);

    useEffect(() => {
        let currentProjectType = getType();

		if (currentProjectType?.id) {
			setSelectedSpace(currentProjectType);
		}
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
		if (selectedSpace && selectedSpace.id) {
			setType(selectedSpace);
		}
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedSpace]);

    const handleError = (message) => {
        if (typeof onError === 'function') {
            onError(message);
        }
    }

    const handleSpaceChange = (e, space) => {
        if ((!selectedSpace || space.id !== selectedSpace.id) && space.enabled) {
            setSelectedSpace(space);

            if (typeof onSpaceChange === 'function') {
                onSpaceChange(space);
            }
        }
    }

    const spaceAssets = {
        'Bathroom': Bathroom,
        'Kitchen': Kitchen,
        'Living': Living
    }

    var spaces = projectTypeApi.data
        ? projectTypeApi.data.filter((projectType) => projectType.visible)
            .map(
                (projectType) =>
                    <div key={projectType.id}
                        className={"item-select space-select" + 
                            (selectedSpace && selectedSpace.id === projectType.id ? ' selected' : '') +
                            (!projectType.enabled ? ' disabled' : ' enabled')
                        }
                        onClick={(event) => handleSpaceChange(event, projectType)}>
                        <div className="cont-img cont-space">
                            <img
                                key={projectType.id}
                                src={spaceAssets[projectType.description] !== undefined ? spaceAssets[projectType.description] : Living}
                                alt={projectType.description}
                            />
                        </div>
                        <h4>{projectType.description}</h4>
                    </div>
            )
        : [];
    
    return (
        <Fragment>
            {
                projectTypeApi.data && spaces.length > 0 &&
                <section className="m-t-12 carousel-container">
                        <div className="carousel-options">
                            {spaces}
                        </div>
                </section>
            }
            {
                (projectTypeApi.error || (projectTypeApi.data && spaces.length === 0)) &&
                <div className='builde-cont container mt-3'>
                    <div className='row'>
                        <div className='col-12'>
                            <Label>Sorry, no spaces are available at this time</Label>
                        </div>
                    </div>
                </div>
                
            }
            {
                projectTypeApi.loading &&
                <Row>
                    <Col md={12} className="text-center">
                        <Spinner/>
                    </Col>
                </Row>
            }
        </Fragment>
    );
}

export default SpaceSelection;